// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"95e35a80","109":"dd3e690d","653":"cba28714","664":"5f94ad2a","900":"7b36e2dd"}[chunkId] + ".chunk.js";
};